import axios from "axios";

import {
  FETCH_ENTRIES,
  FETCH_ENTRY,
  EDIT_ENTRY,
  RESET_EDITED_KUNDE,
  SET_ADRESS_LIST,
  SET_KUNDEN_ID,
  SET_KONTO_SELECTED,
} from "./types/kunden-types";
import console from "../utils/functions/console";
import sendError from "../utils/functions/sendError";

export const fetchEntries = (axiosObject) => async dispatch => {
  const response = await axios[axiosObject.request.type](axiosObject.url)
    .catch(err => {
      console.error("fetch kunde entries", err);
      sendError(err, "kunden-action");
      throw err;
    });
  if (response && response.data && response.data.listKunde && Array.isArray(response.data.listKunde)) {
    return dispatch({ type: FETCH_ENTRIES, payload: response.data.listKunde });
  } else if (response && response.data) {
    return dispatch({ type: FETCH_ENTRIES, payload: response.data });
  } else {
    return response || {};
  }

};

export const fetchEntry = (axiosObject) => async dispatch => {
  const response = await axios[axiosObject.request.type](axiosObject.url, axiosObject.json || undefined)
    .catch(err => {
      console.error("fetch kunde entry", err);
      sendError(err, "kunden-action");
      throw err;
    });
  if (response && response.data && response.data.kunde && response.data.kunde.id) {
    dispatch(setKundenId(response.data.kunde.id));
    dispatch({ type: FETCH_ENTRY, payload: response.data.kunde });
    return response.data.kunde;
  } else if (response && response.data) {
    dispatch({ type: FETCH_ENTRY, payload: response.data });
    return response.data;
  } else {
    return response || {};
  }

};

export const editEntry = (axiosObject, formValues) => async dispatch => {
  let data;
  if (axiosObject && !formValues && axiosObject.json) {
    data = axiosObject.json;
  } else {
    data = {
      header: {},
      kunde: { ...formValues }
    };
  }
  await axios[axiosObject.request.type](axiosObject.url, data)
    .catch(err => {
      console.error("edit kunde entry", err);
      sendError(err, "kunden-action");
      throw err;
    });
  return dispatch({ type: EDIT_ENTRY, payload: data.kunde });
};

export const editEntryLandingPage = (axiosObject, requestData) => async dispatch => {
  if (axiosObject && !requestData && axiosObject.json) {
    requestData = axiosObject.json;
  }
  const response = await axios[axiosObject.request.type](axiosObject.url, requestData)
    .catch(err => {
      console.error("edit kunde entry", err);
      sendError(err, "kunden-action");
      throw err;
    });    
  if (response && response.data && response.data.kunde && response.data.kunde.id) {    
    return dispatch({ type: EDIT_ENTRY, payload: response.data.kunde });
  } else {
    return dispatch({ type: EDIT_ENTRY, payload: requestData.kunde });
  }
};

export function resetEditedKunde() {
  return {
    type: RESET_EDITED_KUNDE
  };
}

export function setAdressList(adressList) {
  return {
    type: SET_ADRESS_LIST,
    payload: adressList
  };
}

export function setKundenId(kundenId) {
  return {
    type: SET_KUNDEN_ID,
    payload: kundenId
  };
}

export function setKunde(kunde) {
  return {
    type: FETCH_ENTRY,
    payload: kunde
  };
}

export function setKontoSelected(value) {
  return {
    type: SET_KONTO_SELECTED,
    payload: value
  };
}
